(function () {
  if (window.ODStreamingVisualCardInit) {
    return;
  }

  function clamp(value) {
    return Math.max(0, Math.min(255, Math.round(value)));
  }

  function rgbToHsl(color) {
    var r = color.r / 255;
    var g = color.g / 255;
    var b = color.b / 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h;
    var s;
    var l = (max + min) / 2;

    if (max === min) {
      h = 0;
      s = 0;
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        default:
          h = (r - g) / d + 4;
          break;
      }

      h /= 6;
    }

    return { h: h, s: s, l: l };
  }

  function hslToRgb(hsl) {
    var h = hsl.h;
    var s = hsl.s;
    var l = hsl.l;
    var r;
    var g;
    var b;

    if (s === 0) {
      r = g = b = l;
    } else {
      function hueToRgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      }

      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hueToRgb(p, q, h + 1 / 3);
      g = hueToRgb(p, q, h);
      b = hueToRgb(p, q, h - 1 / 3);
    }

    return {
      r: clamp(r * 255),
      g: clamp(g * 255),
      b: clamp(b * 255)
    };
  }

  function toRgba(color, alpha) {
    return 'rgba(' + clamp(color.r) + ', ' + clamp(color.g) + ', ' + clamp(color.b) + ', ' + alpha + ')';
  }

  function toRgbChannels(color) {
    return clamp(color.r) + ', ' + clamp(color.g) + ', ' + clamp(color.b);
  }

  function isFreeStreamingCard(card) {
    return card.classList.contains('free-streaming-card');
  }

  function distance(a, b) {
    var dr = a.r - b.r;
    var dg = a.g - b.g;
    var db = a.b - b.b;
    return Math.sqrt(dr * dr + dg * dg + db * db);
  }

  function enhanceColor(color, saturationBoost, lightnessAdjust) {
    var hsl = rgbToHsl(color);
    hsl.s = Math.max(0, Math.min(1, hsl.s + saturationBoost));
    hsl.l = Math.max(0, Math.min(1, hsl.l + lightnessAdjust));
    return hslToRgb(hsl);
  }

  function blendCandidates(pool, limit) {
    var totalWeight = 0;
    var red = 0;
    var green = 0;
    var blue = 0;
    var count = Math.min(pool.length, limit || pool.length);

    for (var index = 0; index < count; index += 1) {
      var candidate = pool[index];
      var weight = Math.max(candidate.weight, 0.01);
      totalWeight += weight;
      red += candidate.color.r * weight;
      green += candidate.color.g * weight;
      blue += candidate.color.b * weight;
    }

    if (!totalWeight) {
      return null;
    }

    return {
      r: clamp(red / totalWeight),
      g: clamp(green / totalWeight),
      b: clamp(blue / totalWeight)
    };
  }

  function getCardLabel(card) {
    return card.getAttribute('data-product-handle') || card.getAttribute('data-handle') || 'unknown-card';
  }

  function describeRoot(root) {
    if (!root || root === document) return 'document';
    if (root === document.documentElement) return 'documentElement';
    if (root === document.body) return 'body';
    if (root.id) return '#' + root.id;
    if (root.className && typeof root.className === 'string') {
      return root.tagName.toLowerCase() + '.' + root.className.trim().replace(/\s+/g, '.');
    }
    if (root.tagName) return root.tagName.toLowerCase();
    return 'unknown-root';
  }

  function logCardState(card, stage, extra) {
    var payload = extra || {};
    payload.card = getCardLabel(card);
    payload.ready = card.getAttribute('data-gradient-ready');
    payload.fallback = card.getAttribute('data-gradient-fallback');
    payload.pending = card.getAttribute('data-gradient-pending');
    console.log('[StreamingCardGradient]', stage, payload);
  }

  function setFallback(card) {
    card.style.setProperty('--dominant-rgb', '132, 54, 150');
    card.style.setProperty('--free-stream-secondary-rgb', '76, 28, 96');

    if (isFreeStreamingCard(card)) {
      card.style.setProperty('--free-stream-gradient-start', 'rgba(132, 54, 150, 0.42)');
      card.style.setProperty('--free-stream-gradient-mid', 'rgba(132, 54, 150, 0.22)');
      card.style.setProperty('--free-stream-gradient-end', 'rgba(255, 255, 255, 1)');
      card.style.setProperty('--free-stream-glow', 'rgba(132, 54, 150, 0.28)');
      card.style.setProperty('--free-stream-shadow', 'rgba(15, 23, 42, 0.12)');
    } else {
      card.style.setProperty('--free-stream-gradient-start', 'rgba(132, 54, 150, 0.9)');
      card.style.setProperty('--free-stream-gradient-mid', 'rgba(76, 28, 96, 0.65)');
      card.style.setProperty('--free-stream-gradient-end', 'rgb(42, 42, 48)');
      card.style.setProperty('--free-stream-glow', 'rgba(132, 54, 150, 0.5)');
      card.style.setProperty('--free-stream-shadow', 'rgba(0, 0, 0, 0.5)');
    }

    card.setAttribute('data-gradient-fallback', 'true');
    card.removeAttribute('data-gradient-ready');
    card.removeAttribute('data-gradient-pending');
    logCardState(card, 'fallback-applied');
  }

  function markGradientSuccess(card, extra) {
    card.setAttribute('data-gradient-ready', 'true');
    card.removeAttribute('data-gradient-fallback');
    card.removeAttribute('data-gradient-pending');
    logCardState(card, 'sampling-succeeded', extra || {});
  }

  function processCard(card) {
    var image = card.querySelector('img');

    if (!image) {
      logCardState(card, 'missing-image-using-fallback');
      setFallback(card);
      return;
    }

    logCardState(card, 'process-card-image-state', {
      complete: image.complete,
      naturalWidth: image.naturalWidth,
      currentSrc: image.currentSrc || image.src || ''
    });

    var run = function () {
      window.setTimeout(function () {
        try {
          var canvas = document.createElement('canvas');
          var context = canvas.getContext('2d', { willReadFrequently: true });
          if (!context) {
            logCardState(card, 'missing-canvas-context-using-fallback');
            setFallback(card);
            return;
          }

          canvas.width = 24;
          canvas.height = 24;
          context.drawImage(image, 0, 0, 24, 24);

          var pixels = context.getImageData(0, 0, 24, 24).data;
          var candidates = [];

          for (var i = 0; i < pixels.length; i += 4) {
            var alpha = pixels[i + 3];
            if (alpha < 32) continue;
            var color = {
              r: pixels[i],
              g: pixels[i + 1],
              b: pixels[i + 2]
            };
            var hsl = rgbToHsl(color);
            var max = Math.max(color.r, color.g, color.b);
            var min = Math.min(color.r, color.g, color.b);
            var spread = max - min;

            if (hsl.s < 0.18) continue;
            if (hsl.l < 0.12 || hsl.l > 0.82) continue;
            if (spread < 26) continue;
            if (max > 232 && spread < 48) continue;
            if (min > 185 && hsl.s < 0.32) continue;

            candidates.push({
              color: color,
              hsl: hsl,
              weight: (hsl.s * 1.9) + ((0.72 - Math.abs(hsl.l - 0.46)) * 0.6) + (spread / 255) * 0.85
            });
          }

          if (!candidates.length) {
            logCardState(card, 'no-viable-candidates-using-fallback');
            setFallback(card);
            return;
          }

          candidates.sort(function (a, b) {
            return b.weight - a.weight;
          });

          var primaryPool = candidates.slice(0, Math.min(candidates.length, 6));
          var primarySeed = blendCandidates(primaryPool, 6) || candidates[0].color;
          var secondaryPool = [];

          for (var c = 1; c < candidates.length; c += 1) {
            if (distance(primarySeed, candidates[c].color) > 42) {
              secondaryPool.push(candidates[c]);
            }

            if (secondaryPool.length >= 6) {
              break;
            }
          }

          var secondarySeed = blendCandidates(secondaryPool, 6);

          if (!secondarySeed) {
            secondarySeed = enhanceColor(primarySeed, -0.08, -0.12);
          }

          var primaryAmbient = enhanceColor(primarySeed, 0.25, 0.02);
          var secondaryAmbient = enhanceColor(secondarySeed, 0.14, -0.08);
          var glow = enhanceColor(primarySeed, 0.2, 0.1);

          card.style.setProperty('--dominant-rgb', toRgbChannels(primaryAmbient));
          card.style.setProperty('--free-stream-secondary-rgb', toRgbChannels(secondaryAmbient));

          if (isFreeStreamingCard(card)) {
            card.style.setProperty('--free-stream-gradient-start', toRgba(primaryAmbient, 0.42));
            card.style.setProperty('--free-stream-gradient-mid', toRgba(primaryAmbient, 0.22));
            card.style.setProperty('--free-stream-gradient-end', 'rgba(255, 255, 255, 1)');
            card.style.setProperty('--free-stream-glow', toRgba(glow, 0.28));
            card.style.setProperty('--free-stream-shadow', 'rgba(15, 23, 42, 0.12)');
          } else {
            card.style.setProperty('--free-stream-gradient-start', toRgba(primaryAmbient, 0.95));
            card.style.setProperty('--free-stream-gradient-mid', toRgba(secondaryAmbient, 0.78));
            card.style.setProperty('--free-stream-gradient-end', 'rgb(42, 42, 48)');
            card.style.setProperty('--free-stream-glow', toRgba(glow, 0.56));
            card.style.setProperty('--free-stream-shadow', 'rgba(0, 0, 0, 0.54)');
          }

          markGradientSuccess(card, {
            currentSrc: image.currentSrc || image.src || '',
            primarySeed: primarySeed,
            secondarySeed: secondarySeed,
            primaryAmbient: primaryAmbient,
            secondaryAmbient: secondaryAmbient,
            glow: glow,
            gradientStart: card.style.getPropertyValue('--free-stream-gradient-start').trim(),
            gradientMid: card.style.getPropertyValue('--free-stream-gradient-mid').trim(),
            gradientEnd: card.style.getPropertyValue('--free-stream-gradient-end').trim(),
            gradientGlow: card.style.getPropertyValue('--free-stream-glow').trim(),
            dominantRgb: card.style.getPropertyValue('--dominant-rgb').trim()
          });
        } catch (error) {
          logCardState(card, 'sampling-error-using-fallback', { error: error && error.message ? error.message : String(error) });
          setFallback(card);
        }
      }, 20);
    };

    if (image.complete && image.naturalWidth > 0) {
      logCardState(card, 'image-ready-starting-sampling', { naturalWidth: image.naturalWidth });
      run();
    } else {
      logCardState(card, 'image-not-ready-waiting-for-load', {
        complete: image.complete,
        naturalWidth: image.naturalWidth
      });
      image.addEventListener('load', run, { once: true });
      image.addEventListener('error', function () {
        logCardState(card, 'image-load-error-using-fallback');
        setFallback(card);
      }, { once: true });
    }
  }

  function init(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('[data-streaming-gradient-card]');

    console.log('[StreamingCardGradient] init', {
      root: describeRoot(scope),
      rootIsDocument: scope === document,
      cardCount: cards.length
    });

    cards.forEach(function (card) {
      logCardState(card, 'card-seen-during-init');

      if (card.getAttribute('data-gradient-ready') === 'true') {
        logCardState(card, 'skipping-already-ready');
        return;
      }

      if (card.getAttribute('data-gradient-pending') === 'true') {
        logCardState(card, 'skipping-pending');
        return;
      }

      if (card.getAttribute('data-gradient-fallback') === 'true') {
        logCardState(card, 'retrying-fallback-card');
      } else {
        logCardState(card, 'starting-card-init');
      }

      card.setAttribute('data-gradient-pending', 'true');
      processCard(card);
    });
  }

  window.ODStreamingVisualCardInit = init;
  window.ODFreeStreamingTitlesInit = init;
})();
